module.exports = __webpack_public_path__ + "static/media/icon-Plus-gray.0787593b.svg";